import { ReactNode } from "react";
import { Card, CardContent } from "@mui/material";

interface BaseTransactionCardProps {
  children: ReactNode;
  minHeight?: number | string;
  dataCypress?: string;
}

/**
 * Base card component that provides standardized styling for all transaction cards
 */
export const BaseTransactionCard = ({
  children,
  minHeight,
  dataCypress,
}: BaseTransactionCardProps) => {
  return (
    <Card
      data-cypress={dataCypress}
      sx={{
        borderRadius: 3,
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        "&:hover": {
          boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
          transform: "translateY(-2px)",
          transition: "all 0.2s ease-in-out",
        },
        border: "1px solid #e0e0e0",
        bgcolor: "#ffffff",
        overflow: "hidden",
        transition: "all 0.2s ease-in-out",
        minHeight: minHeight,
      }}
    >
      <CardContent
        sx={{ p: { xs: 2, sm: 3 }, "&:last-child": { pb: { xs: 2, sm: 3 } } }}
      >
        {children}
      </CardContent>
    </Card>
  );
};
